module.exports = __webpack_public_path__ + "img/Checkmark.e5ba2108.svg";